import { render, staticRenderFns } from "./PersonalityTest.vue?vue&type=template&id=426fcaff&scoped=true"
import script from "./PersonalityTest.vue?vue&type=script&lang=js"
export * from "./PersonalityTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426fcaff",
  null
  
)

export default component.exports